import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

// TODO: Refactor this response as it's repeated with the marketplace
export default class GetOrdersResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "orders": [
                    {
                        "number": "1999",
                        "state": "PENDING",
                        "customer_business_name": "Client123BN123",
                        "customer_fantasy_name": "Cliente de fantasia",
                        "customers_order_number": "",
                        "delivery_site_name": "DeliverySite456",
                        "delivery_date": "07-06-2024",
                        "invoice_number": "00012-12345678",
                    },
                ],
            },
            errors: []
        }
    }

    orders() {
        return this.content().orders.map(order => {
            return {
                orderNumber: order.number,
                customerBusinessName: order.customer_business_name,
                customerFantasyName: order.customer_fantasy_name,
                deliverySiteName: order.delivery_site_name,
                deliveryDate: this._adaptDeliveryDate(order.delivery_date),
                customersOrderNumber: order.customers_order_number,
                state: order.state,
                invoiceNumber: order.invoice_number,
            }
        });
    }

    _adaptDeliveryDate(deliveryDate) {
        return dayjs(deliveryDate, 'DD-MM-YYYY');
    }
}